import { Controller } from "@hotwired/stimulus"

// Replie un texte long derrière un « Voir plus ».
//
// Le repli est appliqué ici, en JavaScript, et non dans le HTML : si le JS ne
// s'exécute pas, la description reste lisible en entier. Elle contient les
// tarifs, l'adresse d'envoi et le contact — il n'existe aucune page de détail
// où l'internaute pourrait les retrouver.
export default class extends Controller {
  static targets = ["content", "toggle"]
  static classes = ["clamped"]
  static values = {
    moreLabel: { type: String, default: "Voir plus" },
    lessLabel: { type: String, default: "Voir moins" }
  }

  connect() {
    this.evaluate()

    // La hauteur du texte change quand la police web remplace la police de
    // secours, et quand la largeur change (le texte se répartit sur moins de
    // lignes) : ce qui débordait peut se mettre à tenir, et inversement.
    document.fonts?.ready.then(() => this.evaluate())
    this.onResize = () => this.evaluate()
    window.addEventListener("resize", this.onResize)
  }

  disconnect() {
    window.removeEventListener("resize", this.onResize)
  }

  toggle() {
    this.deployedByUser = !this.expanded
    this.expanded ? this.collapse() : this.expand()
  }

  // Décide si le bouton a une raison d'être. On mesure toujours en position
  // repliée, sinon le contenu occupe toute sa hauteur et ne déborde jamais.
  evaluate() {
    if (this.deployedByUser) return

    this.contentTarget.classList.add(...this.clampedClasses)

    if (this.hiddenHeight() > this.lineHeight()) {
      this.collapse()
      this.toggleTarget.hidden = false
    } else {
      // Moins d'une ligne masquée : le bouton ne révélerait qu'une marge ou
      // une ligne vide. On déplie et on le retire.
      this.expand()
      this.toggleTarget.hidden = true
    }
  }

  hiddenHeight() {
    return this.contentTarget.scrollHeight - this.contentTarget.clientHeight
  }

  lineHeight() {
    const value = parseFloat(getComputedStyle(this.contentTarget).lineHeight)
    return Number.isFinite(value) ? value : 24
  }

  collapse() {
    this.contentTarget.classList.add(...this.clampedClasses)
    this.expanded = false
    this.syncToggle(this.moreLabelValue)
  }

  expand() {
    this.contentTarget.classList.remove(...this.clampedClasses)
    this.expanded = true
    this.syncToggle(this.lessLabelValue)
  }

  syncToggle(label) {
    if (!this.hasToggleTarget) return

    this.toggleTarget.textContent = label
    this.toggleTarget.setAttribute("aria-expanded", String(this.expanded))
  }
}
